import { SwitchProps } from "@mui/material";
import { StyledSwitch } from "./MuiSwitch.style";

const MuiSwitch = (props: SwitchProps) => <StyledSwitch {...props} />;

export default MuiSwitch;
